import { useDispatch, useSelector } from "react-redux";
import { setIsOpenCloseSesionModal, setIsOpenMenu } from "../../redux/slices/ui/ui";
import { isIOS, isMobile } from "react-device-detect";

export const useReduxUI = () => {
	const dispatch = useDispatch();
	const state = useSelector((state) => state.ui);

	const toggledMenuSlice = (value = false) => {
		dispatch(setIsOpenMenu(value));
	};

    const toggledSesionModal = (value = false) => {
        dispatch(setIsOpenCloseSesionModal(value));
    };

	const isMobileView = (isSubmenu = false, callback = () => {}) => {
		callback();

		if (isSubmenu) {
			if (!isMobile || !isIOS) {
				toggledMenuSlice(true);
				return;
			}

			return;
		}

		if (isMobile || isIOS) {
			toggledMenuSlice();
			return;
		}
	};

	return {
		state,
		toggledMenuSlice,
        toggledSesionModal,
		isMobileView,
	};
};
